import { Box } from "@/Box/Box";
import { SceneGrid } from "@/scene/SceneGrid";
import { ToastEmitterOptionsType } from "@/ToastNotifications/ToastEmitter/ToastEmitterOptionsType";
import { ToastNotificationsBus } from "@/ToastNotifications/ToastNotificationsBus";
import { ActionErrorMessage } from "./ActionErrorMessage";
import { ActionRuleChecker } from "./ActionRuleChecker";

export class DeletingRuleChecker extends ActionRuleChecker {

    private rulesToCheck: Function[];
    private sceneObjects: Array<Box>;
    private grid: SceneGrid;

    public constructor (sceneObjects: Array<Box>, grid: SceneGrid) {
        super();
        this.rulesToCheck = [];
        this.sceneObjects = sceneObjects;
        this.grid = grid;
        this.addAllRulesToCheck();
    }

    protected addAllRulesToCheck () {
        this.rulesToCheck.push(this.isBoxUnderAnotherBox.bind(this));
    }

    public isActionPermitted (deletedBox: Box): boolean {
        let actionErrorMessage: ActionErrorMessage | null = null;
        let ifActionPermitted = true;
        this.rulesToCheck.forEach(rule => {
            actionErrorMessage = rule(deletedBox);
            if (actionErrorMessage != null) {
                ifActionPermitted = false;
                ToastNotificationsBus.emit(ToastEmitterOptionsType.error, actionErrorMessage.toToastNotificationsMessage());
            }
        });
        return ifActionPermitted;
    }

    private isBoxUnderAnotherBox (deletedBox: Box):  ActionErrorMessage | null {
        let actionErrorMessage:  ActionErrorMessage | null = null;
        this.sceneObjects.forEach(box => {
            if(box != deletedBox) {
                if(this.grid.getFloorOfBox(deletedBox) != null) {
                    if(this.grid.getFloorOfBox(deletedBox) as number + 1 == this.grid.getFloorOfBox(box)) {
                        if(box.getCollision().checkIFCollideWithOtherSceneObjectNotIncludingBorder(deletedBox.getPosition(), deletedBox.getSize(), { x: true, y: false, z: true})){
                            actionErrorMessage = new ActionErrorMessage("La pièce est en dessous d'une autre pièce");
                        }
                    }
                }
            }
        });
        return actionErrorMessage;
    }
}